import type { DiagramSpec } from "../types"

/** Showcase — demonstrates icons, animated edges, and polished styling */
export const showcaseDiagram: DiagramSpec = {
  id: "showcase",
  name: "VidMax: Full Pipeline",
  description: "Animated pipeline with icons showing the complete video creation flow",
  layers: [
    { id: "input", name: "Input", color: "#818cf8" },
    { id: "ai", name: "AI Generation", color: "#f59e0b" },
    { id: "post", name: "Post-Production", color: "#10b981" },
    { id: "publish", name: "Publish", color: "#ec4899" },
  ],
  nodes: [
    {
      id: "topic",
      label: "Topic & Brief",
      icon: "📋",
      layer: "input",
      rank: 0,
      description: "Channel niche, target audience, content angle",
    },
    {
      id: "research",
      label: "Research",
      icon: "🔍",
      layer: "input",
      rank: 0,
      description: "Trending topics, competitor analysis, SEO keywords",
    },

    {
      id: "script",
      label: "Script Writer",
      icon: "✍️",
      layer: "ai",
      rank: 1,
      description: "Claude Sonnet generates hook, body, CTA",
    },
    {
      id: "voice",
      label: "Voice Synth",
      icon: "🎙️",
      layer: "ai",
      rank: 2,
      description: "ElevenLabs clones voice from 30s sample",
    },
    {
      id: "visuals",
      label: "Visual Gen",
      icon: "🎬",
      layer: "ai",
      rank: 2,
      description: "Seedance creates video from audio + reference",
    },
    {
      id: "music",
      label: "Music & SFX",
      icon: "🎵",
      layer: "ai",
      rank: 2,
      description: "Background music matching tone and pacing",
    },

    {
      id: "edit",
      label: "Auto-Edit",
      icon: "✂️",
      layer: "post",
      rank: 3,
      description: "NanoBanana: captions, transitions, B-roll, color grade",
    },
    {
      id: "thumb",
      label: "Thumbnail",
      icon: "🖼️",
      layer: "post",
      rank: 3,
      description: "AI-generated clickbait thumbnail with A/B variants",
    },
    {
      id: "qa",
      label: "QA Review",
      icon: "✅",
      layer: "post",
      rank: 4,
      description: "Automated checks: audio sync, caption accuracy, brand compliance",
    },

    {
      id: "youtube",
      label: "YouTube",
      icon: "📺",
      layer: "publish",
      rank: 5,
      description: "Long-form upload with SEO metadata",
    },
    {
      id: "tiktok",
      label: "TikTok",
      icon: "📱",
      layer: "publish",
      rank: 5,
      description: "Vertical crop + trending sounds",
    },
    {
      id: "instagram",
      label: "Instagram",
      icon: "📸",
      layer: "publish",
      rank: 5,
      description: "Reels + carousel from key frames",
    },
  ],
  edges: [
    { id: "e1", source: "topic", target: "script" },
    { id: "e2", source: "research", target: "script" },
    { id: "e3", source: "script", target: "voice" },
    { id: "e4", source: "script", target: "visuals" },
    { id: "e5", source: "script", target: "music" },
    { id: "e6", source: "voice", target: "edit" },
    { id: "e7", source: "visuals", target: "edit" },
    { id: "e8", source: "music", target: "edit" },
    { id: "e9", source: "edit", target: "qa" },
    { id: "e10", source: "thumb", target: "qa" },
    { id: "e11", source: "qa", target: "youtube" },
    { id: "e12", source: "qa", target: "tiktok" },
    { id: "e13", source: "qa", target: "instagram" },
  ],
  views: [
    { id: "full", name: "Full Pipeline", layout: "TB" },
    { id: "lr", name: "Left-Right", layout: "LR" },
  ],
  defaultView: "full",
  preferences: {
    nodeWidth: 210,
    rankSpacing: 130,
    nodeGap: 40,
    edgeStyle: "smoothstep",
    edgeColor: "#4a6a8a",
    animateEdges: true,
    showLayerBands: true,
    fitPadding: 0.12,
  },
}
